import React from 'react';
import { Accordion } from '../ui/Accordion';
export function FAQ() {
  const faqs = [{
    question: '¿Sirve si no soy deportista ni biohacker?',
    answer: 'Sí. El 90% de quienes lo usan son personas comunes con vidas ocupadas — no atletas ni obsesivos de la salud. El sistema está diseñado específicamente para la vida real argentina. Si tenés estrés laboral, horarios complicados o simplemente nunca dormiste bien — es exactamente para vos.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Acceso inmediato por email. Después de la compra recibís el link de descarga en menos de 5 minutos directamente a tu casilla. 100% digital, 100% PDF, funciona en cualquier dispositivo.'
  }, {
    question: '¿Qué lo diferencia de lo que hay en YouTube o Google?',
    answer: 'Tres cosas. Primero: está adaptado al contexto argentino — horarios, suplementos disponibles, cultura social, precios reales. Segundo: es un sistema integrado de 6 tomos que se conectan entre sí — no información suelta. Tercero: incluye los protocolos de implementación exactos — no solo el "qué" sino el "cómo" y el "cuándo".'
  }, {
    question: '¿Tiene garantía real?',
    answer: 'Sí. 7 días, devolución del 100%, sin preguntas. La garantía existe porque confiamos en el producto — y porque la tasa de devolución es menor al 1%.'
  }, {
    question: '¿Sirve si ya probé de todo y nada funcionó?',
    answer: 'Es exactamente para eso. Si probaste melatonina, manzanilla, aplicaciones de meditación y técnicas de relajación sin resultado consistente, es porque estabas tratando síntomas sin identificar la causa. El Bono 5 — Tracker de Sabotajes — existe específicamente para identificar TU causa específica con datos reales, no suposiciones.'
  }];
  return <section className="py-24 relative" data-id="element-45">
      <div className="container mx-auto px-4" data-id="element-46">
        <div className="text-center mb-16" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white flex items-center justify-center gap-3" data-id="element-48">
            <span aria-hidden="true" data-id="element-49">❓</span> LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <Accordion items={faqs} data-id="element-50" />
      </div>
    </section>;
}